<template>
    <MainContent title="Crear deportista">
        <template v-slot:header>
            <h3 class="card-title">Datos del deportista</h3>
        </template>
        <template v-slot:content>
            <Stepper ref="stepper" :steps="steps">
                <template #pasoUno="{ changeStep }">
                    <PasoUnoComponent
                        id="paso-1"
                        :paso_activo="true"
                        :base="base"
                        :esMovil="esMovil"
                        :active="false"
                        @terminado="changeStep"
                        @guardarBase="guardarBase"
                    />
                </template>

                <template #pasoDos="{ changeStep }">
                    <PasoDosComponent
                        id="paso-2"
                        :paso_activo="true"
                        :base="base"
                        :esMovil="esMovil"
                        @terminado="changeStep"
                        @volver="() => changeStep(true)"
                        @guardarBase="guardarBase"
                    />
                </template>

                <template #pasoTres="{ changeStep }">
                    <PasoCincoComponent
                        id="paso-5"
                        :paso_activo="true"
                        :base="base"
                        :esMovil="esMovil"
                        @terminado="(data) => { guardarBase(data); changeStep()  }"
                        @volver="() => changeStep(true)"
                    />
                </template>

                <template #pasoCuatro="{ changeStep }">
                    <PasoTresComponent
                        v-if="base.categoria_base && base.categoria_base.tiene_indumentarias"
                        id="paso-3"
                        :paso_activo="true"
                        :base="base"
                        :esMovil="esMovil"
                        :indumentarias-seleccionadas="base.categoria_base.indumentariasElegidas"
                        @terminado="(data) => {
                            guardarBase(data);
                            changeStep();
                        }"
                        @volver="() => changeStep(true)"
                        :key="reloadComponent"
                    />
                </template>

                <template #pasoCinco="{ changeStep }">
                    <PasoCuatroComponent
                        id="paso-4"
                        :paso_activo="true"
                        :base="base"
                        :esMovil="esMovil"
                        @terminado="changeStep"
                        @volver="() => changeStep(true)"
                    />
                </template>

                <template #pasoSeis="{ changeStep }">
                    <PasoSeisComponent
                        id="paso-6"
                        :base="base"
                        :esMovil="esMovil"
                        @terminado="(data) => { guardarBase(data) }"
                        @volver="() => changeStep(true)"
                    />
                </template>
            </Stepper>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import Stepper from "@/components/frontend/events/compra/components/Stepper";
    import PasoUnoComponent from "@/components/backend/bases/components/PasoUnoComponent";
    import PasoDosComponent from "@/components/backend/bases/components/PasoDosComponent";
    import PasoTresComponent from "@/components/backend/bases/components/PasoTresComponent";
    import PasoCuatroComponent from "@/components/backend/bases/components/PasoCuatroComponent";
    import PasoCincoComponent from "@/components/backend/bases/components/PasoCincoComponent";
    import PasoSeisComponent from "@/components/backend/bases/components/PasoSeisComponent.vue";

    export default {
        data() {
            return {
                base: {
                    nacionalidad: "Española",
                },
                categorias_bases: null,
                reloadComponent: 0,
                esMovil: false,
            };
        },
        created() {
            this.updateSteps();
        },
        computed: {
            steps() {
                return this.updateSteps();
            }
        },
        methods: {
            guardarBase(base) {
                this.base = { ...base };
                this.updateSteps();
            },
            onResize() {
                this.esMovil = window.innerWidth < 768
            },
            updateSteps(categoria) {
                if (categoria) {
                    this.base.categoria_base = categoria;
                }

                const baseSteps = [
                    { label: "Datos personales", slot: "pasoUno" },
                    { label: "Datos responsables", slot: "pasoDos" },
                    { label: "Documentación", slot: "pasoTres" }
                ];

                if (this.base.categoria_base && this.base.categoria_base.tiene_indumentarias) {
                    baseSteps.push({ label: "Indumentarias", slot: "pasoCuatro" });
                }

                baseSteps.push(
                    { label: "Descuentos", slot: "pasoCinco" },
                    { label: "Confirmación", slot: "pasoSeis" }
                );

                return baseSteps;
            }
        },
        beforeDestroy() {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', this.onResize, { passive: true })
            }
        },
        mounted() {
            this.onResize()
            window.addEventListener('resize', this.onResize, { passive: true })
        },
        components: {
            MainContent,
            Stepper,
            PasoUnoComponent,
            PasoDosComponent,
            PasoTresComponent,
            PasoCuatroComponent,
            PasoCincoComponent,
            PasoSeisComponent
        }
    };
</script>
